// import dotenv from "dotenv";
import React from "react";
import ReactDOM from "react-dom";
import "react-notifications/lib/notifications.css";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";
import Routes from "./routes/index";
import * as serviceWorker from "./serviceWorker";
import "./themes/scss/index.scss";
// import * as Sentry from "@sentry/react"

// Sentry.init({
//   dsn: "https://9984bad2efe4991c5c543755d494b43a@o4508731514093568.ingest.us.sentry.io/4508736723812353",

//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   debug: false, // Enable debug mode
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["http://preprodadminpanel.thangamayil.in"],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })
// dotenv.config();
ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
